import { useMemo } from "react";

import { useAppSelector } from "@js/hooks";
import type { EmployerBidListBid } from "@js/types/jobs";

import {
  canBeRejected,
  getSelectedBidIds,
} from "../../components/bulk-select-actions/bid-bulk-selection-slice";

export const useSelectedRejectableBids = (bidList: EmployerBidListBid[]) => {
  const selectedBidIds = useAppSelector(getSelectedBidIds);
  const selectedRejectableBids = useMemo(
    () => bidList.filter((bid) => canBeRejected(bid, selectedBidIds)),
    [bidList, selectedBidIds],
  );

  return { selectedRejectableBids };
};
